import { RequestModel } from "./request.model";
import { UserLogged } from "./user-logged.model";
import { constants } from "../utils/constants";

// =================================================================
//                       Abstract State
// =================================================================
abstract class RequestState {
  constructor() {}

  public abstract getCode(): number;
  public abstract getName(): string;
  public abstract getTemplateId(): string;
  public abstract canBeApproved(user: UserLogged): boolean;
  public abstract canModifyReceipts(user: UserLogged): boolean;
  public abstract canBeRejected(user: UserLogged): boolean;
  public abstract canSendReceipts(
    request: RequestModel,
    user: UserLogged
  ): boolean;
  public abstract canBeConfirmed(user: UserLogged): boolean;
  public abstract canBeAccepted(user: UserLogged): boolean;

}

// =================================================================
//                       Concrete States
// =================================================================
class Created extends RequestState {
  public getCode(): number {
    return constants.rules.codes.requestStates.created.value;
  }

  public getName(): string {
    return constants.rules.codes.requestStates.created.name;
  }

  public getTemplateId(): string {
    return constants.rules.codes.requestStates.created.emailTemplate;
  }

  public canBeApproved(user: UserLogged): boolean {
    
    if (
      user.isExecutive() ||
      user.hasRole(constants.rules.codes.roles.supervisor.value)
    )
      return true;
    return false;
  }

  public canModifyReceipts(user: UserLogged): boolean {
    return false;
  }

  public canBeRejected(user: UserLogged): boolean {
    if (
      user.isExecutive() ||
      user.hasRole(constants.rules.codes.roles.supervisor.value)
    )
      return true;
    return false;
  }

  public canSendReceipts(request: RequestModel, user: UserLogged): boolean {
    return false;
  }

  public canBeConfirmed(user: UserLogged): boolean {
    return false;
  }

  public canBeAccepted(user: UserLogged): boolean {
    return false;
  }
}

// =================================================================
// =================================================================
class Pending extends RequestState {
  
  public getCode(): number {
    return constants.rules.codes.requestStates.pending.value;
  }

  public getName(): string {
    return constants.rules.codes.requestStates.pending.name;
  }

  public getTemplateId(): string {
    return constants.rules.codes.requestStates.pending.emailTemplate;
  }

  public canBeRejected(user: UserLogged): boolean {
    if (
      user.isExecutive() ||
      user.hasRole(constants.rules.codes.roles.treasurer.value)
    )
      return true;
    return false;
  }

  public canBeApproved(user: UserLogged): boolean {
    return false;
  }

  public canModifyReceipts(user: UserLogged): boolean {
    if (
      user.isExecutive() ||
      user.hasRole(constants.rules.codes.roles.treasurer.value)
    )
      return true;
    return false;
  }

  public canSendReceipts(request: RequestModel, user: UserLogged): boolean {
    return (
      request.receipts &&
      request.receipts.length > 0 &&
      (user.isExecutive() ||
        user.hasRole(constants.rules.codes.roles.treasurer.value))
    );
  }

  public canBeConfirmed(user: UserLogged): boolean {
    return false;
  }
  public canBeAccepted(user: UserLogged): boolean {
    return false;
  }
}

// =================================================================
// =================================================================
class Approved extends RequestState {
  
  public getCode(): number {
    return constants.rules.codes.requestStates.approved.value;
  }

  public getTemplateId(): string {
    return constants.rules.codes.requestStates.approved.emailTemplate;
  }

  public getTemplateBoId(): string {
    return constants.rules.codes.requestStates.approved.emailTemplateBo;
  }

  public getName(): string {
    return constants.rules.codes.requestStates.approved.name;
  }

  public canBeRejected(user: UserLogged): boolean {
    return false;
  }

  public canBeApproved(user: UserLogged): boolean {
    return false;
  }

  public canModifyReceipts(user: UserLogged): boolean {
    return false;
  }

  public canSendReceipts(request: RequestModel, user: UserLogged): boolean {
    return false;
  }

  public canBeConfirmed(user: UserLogged): boolean {
    return user.isExecutive();
  }
  public canBeAccepted(user: UserLogged): boolean {
    return user.isExecutive();
  }
}

// =================================================================
// =================================================================
class Accepted extends RequestState {
  
  public getCode(): number {
    return constants.rules.codes.requestStates.accepted.value;
  }

  public getTemplateId(): string {
    return constants.rules.codes.requestStates.accepted.emailTemplate;
  }

  public getName(): string {
    return constants.rules.codes.requestStates.accepted.name;
  }

  public canBeRejected(user: UserLogged): boolean {
    return false;
  }

  public canBeApproved(user: UserLogged): boolean {
    return false;
  }

  public canModifyReceipts(user: UserLogged): boolean {
    return false;
  }

  public canSendReceipts(request: RequestModel, user: UserLogged): boolean {
    return false;
  }

  public canBeConfirmed(user: UserLogged): boolean {
    return false;
  }

  public canBeAccepted(user: UserLogged): boolean {
    return false;
  }

}

// =================================================================
// =================================================================
class Finalized extends RequestState {
  
  public getCode(): number {
    return constants.rules.codes.requestStates.finalized.value;
  }

  public getTemplateId(): string {
    return constants.rules.codes.requestStates.finalized.emailTemplate;
  }

  public getName(): string {
    return constants.rules.codes.requestStates.finalized.name;
  }

  public canBeRejected(user: UserLogged): boolean {
    return false;
  }

  public canBeApproved(user: UserLogged): boolean {
    return false;
  }

  public canModifyReceipts(user: UserLogged): boolean {
    return false;
  }

  public canSendReceipts(request: RequestModel, user: UserLogged): boolean {
    return false;
  }

  public canBeConfirmed(user: UserLogged): boolean {
    return false;
  }

  public canBeAccepted(user: UserLogged): boolean {
    return false;
  }

}

// =================================================================
// =================================================================
class FinalizedP extends RequestState {
  
  public getCode(): number {
    return constants.rules.codes.requestStates.finalizedP.value;
  }

  public getTemplateId(): string {
    return constants.rules.codes.requestStates.finalizedP.emailTemplate;
  }

  public getName(): string {
    return constants.rules.codes.requestStates.finalizedP.name;
  }

  public canBeRejected(user: UserLogged): boolean {
    return false;
  }

  public canBeApproved(user: UserLogged): boolean {
    return false;
  }

  public canModifyReceipts(user: UserLogged): boolean {
    return false;
  }

  public canSendReceipts(request: RequestModel, user: UserLogged): boolean {
    return false;
  }

  public canBeConfirmed(user: UserLogged): boolean {
    return false;
  }

  public canBeAccepted(user: UserLogged): boolean {
    return false;
  }

}

// =================================================================
// =================================================================
class Confirmed extends RequestState {
  
  public getCode(): number {
    return constants.rules.codes.requestStates.confirmed.value;
  }

  public getTemplateId(): string {
    return constants.rules.codes.requestStates.confirmed.emailTemplate;
  }

  public getName(): string {
    return constants.rules.codes.requestStates.confirmed.name;
  }

  public canBeRejected(user: UserLogged): boolean {
    return false;
  }

  public canBeApproved(user: UserLogged): boolean {
    return false;
  }

  public canModifyReceipts(user: UserLogged): boolean {
    return false;
  }

  public canSendReceipts(request: RequestModel, user: UserLogged): boolean {
    return false;
  }

  public canBeConfirmed(user: UserLogged): boolean {
    return false;
  }
  public canBeAccepted(user: UserLogged): boolean {
    return false;
  }
}

// =================================================================
// =================================================================
class Formalized extends RequestState {
  
  public getCode(): number {
    return constants.rules.codes.requestStates.formalized.value;
  }

  public getTemplateId(): string {
    return constants.rules.codes.requestStates.formalized.emailTemplate;
  }

  public getName(): string {
    return constants.rules.codes.requestStates.formalized.name;
  }

  public canBeRejected(user: UserLogged): boolean {
    return false;
  }

  public canBeApproved(user: UserLogged): boolean {
    return false;
  }

  public canModifyReceipts(user: UserLogged): boolean {
    return false;
  }

  public canSendReceipts(request: RequestModel, user: UserLogged): boolean {
    return false;
  }

  public canBeConfirmed(user: UserLogged): boolean {
    return false;
  }

  public canBeAccepted(user: UserLogged): boolean {
    return false;
  }
}

// =================================================================
// =================================================================
class Rejected extends RequestState {
  
  public getCode(): number {
    return constants.rules.codes.requestStates.rejected.value;
  }

  public getTemplateId(): string {
    return constants.rules.codes.requestStates.rejected.emailTemplate;
  }

  public getName(): string {
    return constants.rules.codes.requestStates.rejected.name;
  }

  public canBeRejected(user: UserLogged): boolean {
    return false;
  }

  public canBeApproved(user: UserLogged): boolean {
    return false;
  }

  public canModifyReceipts(user: UserLogged): boolean {
    return false;
  }

  public canSendReceipts(request: RequestModel, user: UserLogged): boolean {
    return false;
  }

  public canBeConfirmed(user: UserLogged): boolean {
    return false;
  }

  public canBeAccepted(user: UserLogged): boolean {
    return false;
  }
}

// =================================================================
// =================================================================
class Deserted extends RequestState {
  
  public getCode(): number {
    return constants.rules.codes.requestStates.deserted.value;
  }

  public getTemplateId(): string {
    return constants.rules.codes.requestStates.deserted.emailTemplate;
  }

  public getName(): string {
    return constants.rules.codes.requestStates.deserted.name;
  }

  public canBeRejected(user: UserLogged): boolean {
    return false;
  }

  public canBeApproved(user: UserLogged): boolean {
    return false;
  }

  public canModifyReceipts(user: UserLogged): boolean {
    return false;
  }

  public canSendReceipts(request: RequestModel, user: UserLogged): boolean {
    return false;
  }

  public canBeConfirmed(user: UserLogged): boolean {
    return false;
  }

  public canBeAccepted(user: UserLogged): boolean {
    return false;
  }
}

// =================================================================
//                          Exports
// =================================================================
export {
  RequestState,
  Created,
  Pending,
  Approved,
  Confirmed,
  Formalized,
  Rejected,
  Deserted,
  Accepted,
  Finalized,
  FinalizedP,
};
